"use client";

import ReactModal from "react-modal";

import Modal from "./Modal";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";

import { AnyObject } from "../../models";

type ModalComponent = typeof Modal & {
  Header: typeof Header;
  Body: typeof Body;
  Footer: typeof Footer;
  setAppElement: typeof ReactModal.setAppElement;
};

const Component = Modal as AnyObject;
Component.Header = Header;
Component.Body = Body;
Component.Footer = Footer;
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Component.setAppElement = ReactModal.setAppElement;

export default Component as ModalComponent;
